const createBadgeImage = async (href, size) => {
  const image = new Image();
  image.crossOrigin = 'anonymous';
  image.src = href;
  await image.decode();

  const canvas = document.createElement('canvas');
  canvas.width = size;
  canvas.height = size;
  const context = canvas.getContext('2d');
  const scale = Math.min(size / image.width, size / image.height);
  const width = image.width * scale;
  const height = image.height * scale;
  context.drawImage(
    image,
    (size - width) / 2,
    (size - height) / 2,
    width,
    height
  );
  context.beginPath();
  context.arc(size * 0.77, size * 0.77, size * 0.18, 0, Math.PI * 2);
  context.fillStyle = '#ef4444';
  context.fill();
  context.strokeStyle = '#ffffff';
  context.lineWidth = size * 0.065;
  context.stroke();
  return canvas.toDataURL('image/png');
};

export const createFaviconBadge = badgeHref => {
  // Update every tab icon, including the one rendered without the PWA manifest.
  const favicons = Array.from(
    document.querySelectorAll('link[rel="icon"]')
  ).map(link => ({
    link,
    href: link.getAttribute('href'),
    size: Number.parseInt(link.getAttribute('sizes'), 10) || 32,
  }));
  const badges = new Map();
  let hasUnread = false;

  const update = async unread => {
    hasUnread = unread;
    if (!unread) {
      favicons.forEach(({ link, href }) => {
        link.href = href;
      });
      return;
    }

    await Promise.all(
      favicons.map(async ({ link, href, size }) => {
        if (badgeHref) {
          link.href = badgeHref;
          return;
        }
        const key = `${href}:${size}`;
        if (!badges.has(key)) {
          // Keep the original icon if a custom image fails to load or denies CORS.
          badges.set(
            key,
            createBadgeImage(href, size).catch(() => null)
          );
        }
        const badge = await badges.get(key);
        // Reading notifications or unmounting can happen while the image loads.
        if (hasUnread && badge) link.href = badge;
      })
    );
  };

  return { update, reset: () => update(false) };
};
